// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__3ffcq","name":"styles_name__tifXj","phone":"styles_phone__1TD4l"};